module.exports = __webpack_public_path__ + "img/01_full.87f21908.jpg";